import { Outlet, useLocation, useParams } from 'react-router-dom';

import { LeaveGuardModalSocket } from '@features/campaigns/builder/components/LeaveGuardModalSocket/LeaveGuardModalSocket.tsx';
import PageHeader from '@features/campaigns/builder/components/PageHeader/PageHeader.tsx';
import Stepper from '@features/campaigns/builder/components/Stepper/Stepper';
import { BuilderCampaignDataProvider } from '@features/campaigns/builder/providers/BuilderCampaignDataProvider/BuilderCampaignDataProvider.tsx';
import { BuilderStepNavigationProvider } from '@features/campaigns/builder/providers/BuilderStepNavigationProvider/BuilderStepNavigationProvider.tsx';
import { getStepperActiveIndex } from '@features/campaigns/builder/utils/getStepperActiveIndex.ts';
import { LeaveGuardModalProvider } from '@shared/providers/LeaveGuardModalProvider/LeaveGuardModalProvider';

import styles from './PageLayout.module.scss';

function BuilderPageLayout() {
  const { pathname } = useLocation();
  const { campaignId } = useParams();
  const stepperActiveIndex = getStepperActiveIndex(pathname, campaignId);

  return (
    <BuilderCampaignDataProvider>
      <BuilderStepNavigationProvider>
        <LeaveGuardModalProvider>
          <section>
            <PageHeader />
            <div className='content-wrapper'>
              <div className={styles.stepperContainer}>
                <Stepper activeIndex={stepperActiveIndex} />
              </div>
              <div className={styles.formStepContainer}>
                <Outlet />
              </div>
            </div>
          </section>
          <LeaveGuardModalSocket />
        </LeaveGuardModalProvider>
      </BuilderStepNavigationProvider>
    </BuilderCampaignDataProvider>
  );
}

export default BuilderPageLayout;
